import { get } from 'lodash';
import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable';
import { Subject } from 'rxjs/Subject';
import { ignoreElements, map, mergeMap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

// services
import AnalyticsService from './analytics-provider.service';

// types
import { IEpicCreatorCallback } from 'types/analytics';
import { IEpic } from 'types/epic';
import { IAction } from 'types/action';
import { IModule } from '@sitegen/common/types';

export const initAnalyticsObservable$: Subject<boolean> = new Subject();

export const epic$ = new BehaviorSubject(combineEpics(...[]));

export const createEmptyAnalyticsEpics = (): IEpic => {
    return (action$, store) => epic$.pipe(mergeMap(epic => epic(action$, store, {})));
};

export const loadAnalyticsEpicsAsync = (importPromise: Promise<IModule>): void => {
    importPromise.then(analyticsEpics => {
        epic$.next(analyticsEpics.default);
    });
};

export const analyticsEpicCreator = (
    types: string[],
    callback: IEpicCreatorCallback
) => (
    action$: ActionsObservable<IAction>,
    /* eslint-disable-next-line*/
    store$: StateObservable<any>
) =>
    action$
        .ofType(...types)
        .pipe(
            map(action => {
                callback(action, store$);
            })
        )
        .pipe(ignoreElements());

export const setLanguage = (actionTypes: string[]): IEpic =>
    analyticsEpicCreator(
        actionTypes,
        (action: IAction): void => {
            const language = get(action, 'payload.language', '');
            const country = get(action, 'payload.country', '');

            AnalyticsService.updateAnalyticalData({
                language,
                country,
                countryCode: country.toLowerCase()
            });
        }
    );

export const setUserAnalyticsData = (actionTypes: string[]): IEpic =>
    analyticsEpicCreator(
        actionTypes,
        (action: IAction): void => {
            const userId = get(action, 'payload.UbisoftConnectProfile.user.userId');

            AnalyticsService.updateAnalyticalData({
                errorType: '',
                ubisoftId: userId,
            });
        }
    );

// TODO: merge with analyticLogoutEpic
export const cleanLoginAnalyticsData = (actionTypes: string[]): IEpic =>
    analyticsEpicCreator(
        actionTypes,
        (): void => {
            AnalyticsService.updateAnalyticalData({
                errorType: '',
                ubisoftId: '',
            });
        }
    );

export const setPlatformSelection = (actionTypes: string[]): IEpic =>
    analyticsEpicCreator(
        actionTypes,
        (action: IAction): void => {
            const selectedPlatform = get(action, 'payload.platform');

            AnalyticsService.updateAnalyticalData({
                platformSelection: selectedPlatform.toUpperCase(),
                errorType: ''
            });
        }
    );
